import currentLevel from './currentLevelReducer';
import gameState from './gameStateReducer';
import screen from './screenReducer';
import score from './scoreReducer';

export default {
  currentLevel,
  gameState,
  screen,
  score,
};
